import { FC, memo } from 'react'
import { Button } from '@chakra-ui/react'

import JobsiteCard from 'InstitutionalManagement/components/JobsiteCard'
import { Jobsite } from 'InstitutionalManagement/types'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import { useCustomFormJobsiteSelectionDrawerManager } from '../../../../contexts/CustomFormJobsiteSelectionDrawerManager/Provider'

type Props = {
  jobsite: Jobsite
  onClose: () => void
}

const CustomFormJobsiteCardToSelect: FC<Props> = ({ jobsite, onClose }) => {
  const { questionKey, selectedJobsite, setSelectedJobsite, filter } = useCustomFormJobsiteSelectionDrawerManager()

  const { formMethods } = useCustomFormViewer()

  function selectJobsite(selectedJobsite: Jobsite) {
    formMethods?.setValue(questionKey, [selectedJobsite.id, selectedJobsite.slug, selectedJobsite.name])
    setSelectedJobsite(selectedJobsite)
  }

  function removeJobsite() {
    formMethods?.setValue(questionKey, undefined)
    setSelectedJobsite({})
  }

  return (
    <JobsiteCard jobsite={jobsite} jobsiteFilter={filter}>
      {selectedJobsite?.id === jobsite.id ? (
        <Button width="100%" variant="outline" colorScheme="red" onClick={() => removeJobsite()}>
          Remover
        </Button>
      ) : (
        <Button
          width="100%"
          variant="outline"
          onClick={() => {
            selectJobsite(jobsite)
            onClose()
          }}
        >
          Selecionar
        </Button>
      )}
    </JobsiteCard>
  )
}

export default memo(CustomFormJobsiteCardToSelect)
